import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0cb7b66d")

_pushScopeId("data-v-0cb7b66d")
const _hoisted_1 = {
  key: 0,
  class: "top-0 right-0 fixed mt-12 mr-10 font-montserrat z-60"
}
const _hoisted_2 = { class: "flex items-center gap-x-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "notification" }, {
    default: _withId(() => [
      (_ctx.modelValue)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createVNode("div", {
                class: "rounded-lg p-4 flex items-center justify-between gap-3 whitespace-normal",
                style: _ctx.backgroundColorStyle
              }, [
                _createVNode("div", _hoisted_2, [
                  (_ctx.iconLeftAsset)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: require(`@/app/ui/assets/svg/${_ctx.iconLeftAsset}.svg`),
                        alt: "refresh",
                        class: "w-10 max-w-none"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  _createVNode("div", {
                    class: [" text-12px break-word", _ctx.textColor],
                    innerHTML: _ctx.message
                  }, null, 10, ["innerHTML"])
                ]),
                (_ctx.timeout === 0)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: require(`@/app/ui/assets/svg/x-white.svg`),
                      class: "cursor-pointer w-5 ml-6",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSnackbar && _ctx.closeSnackbar(...args))),
                      alt: "x"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ], 4)
            ], {}, true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
})